import templateUrl from './address.html';

export const addressComponent = {
    bindings: {
        details: '<'
    },

    templateUrl,

    controller: class AddressComponent {
        constructor() {
            'ngInject';

        }

        $onInit() {

        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/address/address.component.js